export default __webpack_public_path__ + "media/images/user_photos/173-176b8484df1fbe57ee468ff7e5eb2100.jpg";